import React from 'react';
import { ParamsContext } from './params-context';
import { ParamsProviderProps } from './params.types';

const ParamsProvider: React.FunctionComponent<ParamsProviderProps> = ({
  portalTypeProp,
  utm,
  activeIcon,
  locale,
  user,
  pages,
  children
}) => {
  return (
    <ParamsContext.Provider
      value={{
        portalType: portalTypeProp,
        utm,
        activeIcon,
        locale,
        user,
        pages
      }}>
      {children}
    </ParamsContext.Provider>
  );
};
export default ParamsProvider;
